import {Api} from '../services/Api';

const User = {
  signIn: async (body) => {
    return await Api.post('/sign_in_dashboard', body);
  },
  rescueUser: async (body) => {
    return await Api.post('/find_user_login_dashboard', body);
  },
  signInJwt: async (body) => {
    return await Api.post('/sign_in_generic_jwt', body);
  },
  sendCoordinates: async (body) => {
    return await Api.post('/coordinates_dashboard', body);
  },
  sendOtp: async (body) => {
    return await Api.post('/otp_dashboard', body);
  },
  signOut: async (body) => {
    return await Api.post('/sign_out', body);
  },
  azureSignIn: async (body) => {
    return await Api.post('/sign_in_dashboard_azure', body);
  },
  sendResetPasswordEmail: async (email) => {
    return await Api.post('/send_reset_password_email', email);
  },
  passwordReset: async (email) => {
    return await Api.put('/password_reset', email);
  },
  updateUserAttribute: async (data) => {
    return await Api.put('/current_user', data);
  },
}

export default User;
